<div id="lista" class="page-layout carded fullwidth">

    <!-- TOP BACKGROUND -->
    <div class="top-bg accent"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">

        <!-- HEADER -->
        <div class="header accent"
             fxLayout="column" fxLayoutAlign="center center"
             fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="space-between center">

            <!-- APP TITLE -->
            <div class="logo mb-24 mb-md-0"
                 fxLayout="row" fxLayoutAlign="start center">
                <mat-icon class="logo-icon s-32 mr-16">
                    business
                </mat-icon>
                <span class="logo-text h1">
                    Assunto da Lista de Atividades
                </span>

                <button mat-mini-fab 
                color="accent"
                matTooltip="Adicionar Assunto"
                (click)="openCadastro()"
                style="margin-left: 16px;">
                <mat-icon>add_circle</mat-icon>
                </button>

            </div>
            <!-- / APP TITLE -->

            <!-- SEARCH -->
            <div class="search-wrapper mx-32 mx-md-0">
                <div class="search" fxFlex fxLayout="row" fxLayoutAlign="start center">                    
                    <input 
                        #filter 
                        placeholder="Buscar Por Nome"
                        [formControl]="search"
                        (keyup)="onEnter(filter.value)"
                        (keyup.enter)="onEnter(filter.value)"
                    >
                    <mat-icon 
                        style="cursor: pointer;" 
                        (click)="getAll()"
                    >
                        search
                    </mat-icon>
                </div>
            </div>                    
            <!-- / SEARCH -->
          
        </div>
        <!-- / HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card">
            <ngx-datatable 
                #table 
                class='material' 
                [loadingIndicator]="loadingIndicator"
                [columns]="columns" 
                [columnMode]="'force'" 
                [headerHeight]="50"                       
                [footerHeight]="50" 
                [rowHeight]="'auto'" 
                [rows]='rows'>

                <ngx-datatable-column name="Nome" prop="nome" [sortable]="false">
                    <ng-template let-rowIndex="rowIndex" let-nome="value" ngx-datatable-cell-template>
                        {{nome}}
                    </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Assunto Prosperidade" prop="is_subject_prosperidade" [sortable]="false">
                    <ng-template let-rowIndex="rowIndex" let-is_subject_prosperidade="value" ngx-datatable-cell-template>
                        {{is_subject_prosperidade? 'Sim' : 'Não'}}
                    </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="É visível por parceiros" prop="is_visible" [sortable]="false">
                    <ng-template let-rowIndex="rowIndex" let-is_visible="value" ngx-datatable-cell-template>
                        {{getDescricaoVisivel(is_visible)}}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Ação" prop="id" [sortable]="false">
                    <ng-template let-rowIndex="rowIndex" let-id="value" ngx-datatable-cell-template>
                        <button mat-icon-button matTooltip="Alterar Assunto" (click)="openAlterar(id)">
                            <mat-icon aria-label="Editar Assunto">edit</mat-icon>
                        </button>

                        <button mat-icon-button color="warn" matTooltip="Excluir Assunto" (click)="delete(id)">
                            <mat-icon aria-label="Excluir Assunto">delete</mat-icon>
                        </button>
                    </ng-template>
                </ngx-datatable-column>

            </ngx-datatable>

            <div style="padding: 5px 10px">
                <mat-paginator 
                    #paginator 
                    [length]="length"
                    [pageSize]="pageSize"
                    [pageSizeOptions]="pageSizeOptions"
                    (page)="pageEvent($event)">
                </mat-paginator>
            </div>
        </div>
    </div>
</div>